<template lang="html">
  <div class="row col-at-sm col-at-md">
    <doughnut :total="client.seven_day_totals.momentum">Momentum</doughnut>
    <doughnut :total="client.seven_day_totals.pulse">Pulse</doughnut>
  </div>
</template>

<script>
import doughnut from "@/components/charts/doughnut";

export default {
  props: ['client'],
  components: {doughnut}
}
</script>

<style lang="css" scoped>
</style>
